<div class="register-container">
  <div class="register-card glass-panel reveal-on-scroll">
    <div class="register-header">
      <img src="logo.svg" alt="Radical Events" class="auth-logo">
      <h2 class="text-gradient">Crie sua conta</h2>
      <p>Junte-se à maior comunidade de eventos radicais</p>
    </div>

    <mat-card-content>
      <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" class="register-form">
        
        <mat-form-field appearance="outline">
          <mat-label>Nome Completo</mat-label>
          <input matInput formControlName="name" placeholder="Como quer ser chamado?">
          <mat-icon matSuffix>person</mat-icon>
          <mat-error *ngIf="registerForm.get('name')?.invalid">Nome é obrigatório (mín. 3 caracteres)</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>E-mail</mat-label>
          <input matInput formControlName="email" type="email" placeholder="seu@email.com">
          <mat-icon matSuffix>email</mat-icon>
          <mat-error *ngIf="registerForm.get('email')?.invalid">E-mail inválido</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Telefone</mat-label>
          <input matInput formControlName="phone" mask="(00) 00000-0000" placeholder="(00) 00000-0000">
          <mat-icon matSuffix>phone</mat-icon>
          <mat-error *ngIf="registerForm.get('phone')?.invalid">Telefone é obrigatório</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>CPF</mat-label>
          <input matInput formControlName="cpf" mask="000.000.000-00" placeholder="000.000.000-00">
          <mat-icon matSuffix>assignment_ind</mat-icon>
          <mat-error *ngIf="registerForm.get('cpf')?.invalid">CPF inválido</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Senha</mat-label>
          <input matInput [type]="showPassword ? 'text' : 'password'" formControlName="password">
          <button mat-icon-button matSuffix (click)="togglePassword()" type="button">
            <mat-icon>{{showPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
          </button>
          <mat-error *ngIf="registerForm.get('password')?.invalid">Mínimo 6 caracteres</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Confirmar Senha</mat-label>
          <input matInput [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword">
          <button mat-icon-button matSuffix (click)="toggleConfirmPassword()" type="button">
            <mat-icon>{{showConfirmPassword ? 'visibility' : 'visibility_off'}}</mat-icon>
          </button>
          <mat-error *ngIf="registerForm.hasError('mismatch')">As senhas não coincidem</mat-error>
        </mat-form-field>

        <div class="checkbox-group">
          <mat-checkbox formControlName="terms" color="primary">
            Eu aceito os <a routerLink="/termos" target="_blank" class="inline-link">Termos de Uso</a> e a <a routerLink="/privacidade" target="_blank" class="inline-link">Política de Privacidade</a>
          </mat-checkbox>
        </div>

        <button mat-raised-button color="accent" class="submit-button" type="submit" [disabled]="registerForm.invalid">
          CRIAR CONTA
        </button>
      </form>

      <div class="register-footer">
        Já tem uma conta? <a routerLink="/auth/login" class="login-link">Faça Login</a>
      </div>
    </mat-card-content>
  </div>
</div>
